import React from 'react';
import { H3, P3 } from '../../../../../styles/FontStyles';
import { Button } from '../../../../../styles/GlobalComponents';
import { color } from '../../../../../styles/GlobalStyles';
import { Icon, IconStructureAlert } from '../../../../../styles/Icons';
import { FlexJustifyCenter } from '../../../../../styles/stylesStyled';
import { Circle, Tab } from './UserVerification.styles';

export const UserStatuses = ({ setIsOpen }) => {
  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
        <Circle color={color.colors.error500}>
          <Icon pointer w='34px' color={color.colors.neutral50}>
            <IconStructureAlert height={30} width={5} />
          </Icon>
        </Circle>
        <H3 mb='4'>What are these statuses?</H3>
        <P3 mb='40' color={color.colors.neutral500}>
          Below you can find an explanation of these statuses.
        </P3>
      </div>
      <Tab style={{ margin: 0, display: 'inline-block' }}>
        User not verified
      </Tab>
      <P3 color={color.colors.neutral900} mb='25' mt='8'>
        User needs to complete his KYC form.
      </P3>

      <Tab style={{ margin: 0, display: 'inline-block' }}>
        No BigWhale Package
      </Tab>
      <P3 color={color.colors.neutral900} mb='25' mt='8'>
        User has not ordered his BigWhale Package.
      </P3>

      <Tab style={{ margin: 0, display: 'inline-block' }}>
        Waiting Package payment
      </Tab>
      <P3 color={color.colors.neutral900} mb='25' mt='8'>
        User has ordered his BigWhale Package but not yet paid for it.
      </P3>

      <Tab style={{ margin: 0, display: 'inline-block' }}>
        Not Qualified Partner Rank
      </Tab>
      <P3 color={color.colors.neutral900} mb='25' mt='8'>
        User has not yet achieved Qualified Partner rank to receive team bonus
        with one sponsored partner on the left and one sponsored partner on the
        right team.
      </P3>
      <FlexJustifyCenter>
        <Button mt='40' maxWidth='200px' onClick={() => setIsOpen(false)}>
          Close
        </Button>
      </FlexJustifyCenter>
    </div>
  );
};
